import React, { Component, useContext, useEffect, useState } from 'react';
import { Chart } from 'chart.js';

import {
  getTopTenItemInfo,
  getTodayTopThreeItemInfo,
  getMakeShopProductList,
  getUserDetail
} from '../../modules/NetworkFunction';
import * as XLSX from 'xlsx';
import '../../index.css';
import StatisticsModal from './StatisticsModal';
import AuthContext from '../../contexts/AuthContext';
import ShopModeContext from '../../contexts/ShopModeContext';
import Title from '../../components/Title';
import { returnMessageFromCode } from '../../utils/ErrorAlertComponent';

let ctx;
let chart;
const colorList = [
  '#FF650E',
  '#FF7A00',
  '#FFA800',
  '#FFD600',
  '#ECD458',
  '#D6CB91',
  '#BCB591',
  '#9E9D93',
  '#898984',
  '#595959',
];

function MyPageStatistics() {
  const { auth } = useContext(AuthContext);
  const { shopMode } = useContext(ShopModeContext);
  const token = auth;

  const [year, setYear] = useState(0);
  const [month, setMonth] = useState(0);

  const [isTopTenProductLoaded, setIsTopTenProductLoaded] =
    React.useState(false);
  const [isTopThreeProductLoaded, setIsTopThreeProductLoaded] =
    React.useState(false);

 

  const [productList, setProductList] = React.useState([]);
  const [makeShopProductList, setMakeShopProductList] = useState([]);
  const [topThreeProductList, setTopThreeProductList] = React.useState([]);
  const [isUserLoaded, setIsUserLoaded] = useState(false);


  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  React.useEffect(() => {
    let date = new Date();

    setYear(date.getFullYear());
    setMonth(date.getMonth() + 1);

    const canvas = document.getElementById('chart');
    if (canvas) {
      ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, 100, 100);
  
      if (!isTopTenProductLoaded) {
        getTopTenItemInfo(
          null,
          (v) => {
            console.log(v.results);
            setProductList(v.results);
          },
          setIsTopTenProductLoaded,
          (e) => {
            console.log(e);
          },
          token
        );
      }
  
      if (!isTopThreeProductLoaded) {
        getTodayTopThreeItemInfo(
          null,
          (v) => {
            console.log(v.results);
            setTopThreeProductList(v.results);
          },
          setIsTopThreeProductLoaded,
          (e) => {
            console.log(e);
          },
          token
        );
      }
  
      drawChart();
      return () => {
        if (chart) chart.destroy();
      };
    } else {
      console.error("Canvas element with id 'chart' not found");
    }}, [
    isTopTenProductLoaded,
    isTopThreeProductLoaded,
    productList,
    token,
    topThreeProductList,
    shopMode,
    makeShopProductList
  ]);

  useEffect(() => {
    
    if (shopMode === 'makeshop') {
      if (!isUserLoaded) {
        getUserDetail(
          null,
          (v) => {
            console.log(v);
            
              const makeshopDomain = new URL(v?.user.makeshopURL).hostname;
              getMakeShopProductList(
                {
                  shopDomain: makeshopDomain,
                  shopKey: v?.user.makeshopKey,
                },
                (data) => {
                  if (data.return_code !== '0000') { // 정상 응답이 아닌 경우
                    returnMessageFromCode(data.return_code);
                    return;
                  }
                  console.log(data.list)
                  const sortedMakeShopProductList = data.list.sort((a, b) => Number(b.view_count) - Number(a.view_count));
                  console.log(sortedMakeShopProductList)
                  setMakeShopProductList([...sortedMakeShopProductList]);
                },
                (e) => {
                  console.log(e);
                },
                token
              )
            
          },
          setIsUserLoaded,
          (e) => {
            console.log(e)
          },
          token
        )
      }
    }
    

  }, [ token, shopMode, isUserLoaded, makeShopProductList ])

  const makeExcel_todayTop3 = () => {
    if (
      (shopMode === 'cafe24' && topThreeProductList.length === 0) ||
      (shopMode === 'makeshop' && makeShopProductList.length === 0)
    ) {
      alert('조회된 상품이 없어 빈 엑셀 파일을 생성합니다.');
    }

    const wsData = [];
    const header = ['순위', '상품명', '가격', '조회수'];
    wsData.push(header);

    if (
      (shopMode === 'cafe24' && topThreeProductList.length === 0) ||
      (shopMode === 'makeshop' && makeShopProductList.length === 0)
    ) {
      wsData.push(['-', '-', '-', '-']);
    } else {
      const list = shopMode === 'cafe24' ? topThreeProductList : makeShopProductList;
      for (let i = 0; i < Math.min(3, list.length); i++) {
        const item = list[i];
        wsData.push([
          i + 1,
          shopMode === 'cafe24' ? item.name : item.product_name,
          shopMode === 'cafe24' ? item.price : item.sellprice,
          shopMode === 'cafe24' ? item.count : item.view_count,
        ]);
      }
    }

    const worksheet = XLSX.utils.aoa_to_sheet(wsData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'TOP 3 상품');

    XLSX.writeFile(workbook, '일일 TOP3 상세 조회 상품.xlsx');
  };

  const makeExcel_top10 = () => {
    if (
      (shopMode === 'cafe24' && productList.length === 0) ||
      (shopMode === 'makeshop' && makeShopProductList.length === 0)
    ) {
      alert('조회된 상품이 없어 빈 엑셀 파일을 생성합니다.');
    }

    const wsData = [];
    const header = ['순위', '상품명', '가격', '조회수'];
    wsData.push(header);

    if (
      (shopMode === 'cafe24' && productList.length === 0) ||
      (shopMode === 'makeshop' && makeShopProductList.length === 0)
    ) {
      wsData.push(['-', '-', '-', '-']);
    } else {
      const list = shopMode === 'cafe24' ? productList : makeShopProductList;
      for (let i = 0; i < Math.min(10, list.length); i++) {
        const item = list[i];
        wsData.push([
          i + 1,
          shopMode === 'cafe24' ? item.name : item.product_name,
          shopMode === 'cafe24' ? item.price : item.sellprice,
          shopMode === 'cafe24' ? item.viewCount : item.view_count,
        ]);
      }
    }

    const worksheet = XLSX.utils.aoa_to_sheet(wsData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'TOP 10 상품');

    XLSX.writeFile(workbook, '상위 TOP 10 상품.xlsx');
  };

  const productNameList = productList.map((p) => p.name);
  const productViewCountList = productList.map((p) => p.viewCount);

  const makeShopProductNameList = makeShopProductList.map((p) => p.product_name);
  const makeShopProductViewCountList = makeShopProductList.map((p) => p.view_count);

  const drawChart = () => {
    ctx = document.getElementById('chart').getContext('2d');
    ctx.width = '100px';
    ctx.clearRect(0, 0, 100, 100);
    if (typeof chart !== 'undefined') chart.destroy();
    
    if (shopMode === 'cafe24') {
      chart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: productNameList,
          datasets: [
            {
              data: productList.length > 0 ? productViewCountList : [100],
              backgroundColor: productList.length > 0 ? colorList : '#DDD',
              borderColor: productList.length > 0 ? colorList : '#DDD',
              hoverOffset: 10,
              spacing: productList.length > 0 && 10,
            },
          ],
        },
        options: {
          cutout: '60%',
          radius: '65%',
          plugins: {
            tooltip: {
              enabled: productList.length > 0,
            },
            datalabels: {
              display: false,
            },
          },
        },
      });
    } else {
      chart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: makeShopProductNameList,
          datasets: [
            {
              data: makeShopProductList.length > 0 ? makeShopProductViewCountList : [100],
              backgroundColor: makeShopProductList.length > 0 ? colorList : '#DDD',
              borderColor: makeShopProductList.length > 0 ? colorList : '#DDD',
              hoverOffset: 10,
              spacing: makeShopProductList.length > 0 && 10,
            },
          ],
        },
        options: {
          cutout: '60%',
          radius: '65%',
          plugins: {
            tooltip: {
              enabled: makeShopProductList.length > 0,
            },
            datalabels: {
              display: false,
            },
          },
        },
      });
    }
    
  };

  const topTenArray = () => {
    let array = [];
    for (let i = 0; i < 10; i++) {
      array.push(
        <div
          key={i}
          style={{
            height: 50,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              backgroundColor: `${colorList[i]}`,
              width: 30,
              height: 30,
              borderRadius: '50%',
              textAlign: 'center',
              color: '#fff',
              fontSize: 18,
              fontWeight: 500,
            }}
          >
            {i + 1}
          </div>
          <div
            style={{
              width: '1px',
              height: '80px',
              backgroundColor: '#ccc',
              marginLeft: 25,
            }}
          ></div>
          <div style={{ width: '350px', marginLeft: '25px' }}>
            {productList[i] ? (
              <span style={{ color: 'black' }}>{productList[i].name}</span>
            ) : (
              <span style={{ color: 'gray' }}>데이터 존재하지 않음</span>
            )}
          </div>
          <div
            style={{
              width: '1px',
              height: '80px',
              backgroundColor: '#ccc',
            }}
          ></div>
          <div
            style={{
              width: '140px',
              textAlign: 'center',
            }}
          >
            {productList[i] ? (
              <span style={{ color: 'black' }}>
                {productList[i].finalPrice}원
              </span>
            ) : (
              <span style={{ color: 'gray' }}>- 원</span>
            )}
          </div>
          <div
            style={{
              width: '1px',
              height: '80px',
              backgroundColor: '#ccc',
            }}
          ></div>
          <div
            style={{
              width: '120px',
              textAlign: 'center',
            }}
          >
            {productList[i] ? (
              <span style={{ color: 'black' }}>
                {productList[i].viewCount}회
              </span>
            ) : (
              <span style={{ color: 'gray' }}>- 회</span>
            )}
          </div>
        </div>
      );
    }

    return array;
  };

  const topTenMakeShopProductArray = () => {
    // makeshop 상품 리스트를 view_count로 정렬
    //const sortedMakeShopProductList = makeShopProductList.sort((a, b) => b.view_count - a.view_count);

    // 후 로직 처리
    let array = [];
    for (let i = 0; i < 10; i++) {
      array.push(
        <div
          key={i}
          style={{
            height: 50,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              backgroundColor: `${colorList[i]}`,
              width: 30,
              height: 30,
              borderRadius: '50%',
              textAlign: 'center',
              color: '#fff',
              fontSize: 18,
              fontWeight: 500,
            }}
          >
            {i + 1}
          </div>
          <div
            style={{
              width: '1px',
              height: '80px',
              backgroundColor: '#ccc',
              marginLeft: 25,
            }}
          ></div>
          <div style={{ width: '350px', marginLeft: '25px' }}>
            {makeShopProductList[i] ? (
              <span style={{ color: 'black' }}>{makeShopProductList[i].product_name}</span>
            ) : (
              <span style={{ color: 'gray' }}>데이터 존재하지 않음</span>
            )}
          </div>
          <div
            style={{
              width: '1px',
              height: '80px',
              backgroundColor: '#ccc',
            }}
          ></div>
          <div
            style={{
              width: '140px',
              textAlign: 'center',
            }}
          >
            {makeShopProductList[i] ? (
              <span style={{ color: 'black' }}>
                {makeShopProductList[i].sellprice}원
              </span>
            ) : (
              <span style={{ color: 'gray' }}>- 원</span>
            )}
          </div>
          <div
            style={{
              width: '1px',
              height: '80px',
              backgroundColor: '#ccc',
            }}
          ></div>
          <div
            style={{
              width: '120px',
              textAlign: 'center',
            }}
          >
            {makeShopProductList[i] ? (
              <span style={{ color: 'black' }}>
                {makeShopProductList[i].view_count}회
              </span>
            ) : (
              <span style={{ color: 'gray' }}>- 회</span>
            )}
          </div>
        </div>
      );
    }

    return array;
  }

  const calculateSum = (arr) => {
    
    if (shopMode === 'cafe24') {
      return arr.reduce((acc, cur) => acc + cur.viewCount, 0);
    } else {
      return arr.reduce((acc, cur) => acc + cur.view_count, 0);
    }
  } 

  return (
    <div>
      <StatisticsModal open={modalOpen} close={closeModal} header="상품 통계" />
      <Title title="상품 통계" />

      <div className="inner-box" style={{ marginTop: 30 }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'baseline',
          }}
        >
          <p className="subtitle">일일 상세 조회수 순위</p>
          <p style={{ fontSize: 12, color: '#B5B5B5' }}>
            * 영상에 등장하는 상품의 상세 정보를 고객이 조회한 횟수
          </p>
        </div>
        {
          shopMode === 'cafe24' 
          ? (
          <div
          style={{
            width: 740,
            padding: '10px 0px 10px 20px',
            border: '1px solid #c4c4c4',
            borderRadius: 10,
            backgroundColor: 'white',
            marginBottom: '30px',
            position: 'relative',
          }}
        >
          {Array.from({ length: 3 }, (_, i) => i).map((i) => (
            <div
              key={i}
              style={{
                height: 50,
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <div
                style={{
                  width: 29,
                  height: 29,
                  backgroundColor: '#B5B5B5',
                  borderRadius: '50%',
                  textAlign: 'center',
                  color: '#fff',
                  fontSize: 18,
                  fontWeight: 500,
                }}
              >
                {i + 1}
              </div>
              <div
                style={{
                  width: 1,
                  height: 70,
                  backgroundColor: '#ccc',
                  marginLeft: 20,
                }}
              ></div>
              <div style={{ width: 360, marginLeft: 18, color: 'gray' }}>
                {topThreeProductList[i] ? (
                  <span style={{ color: 'black' }}>
                    {topThreeProductList[i].name || '상품 이름 없음'}{' '}
                  </span>
                ) : (
                  '데이터 존재하지 않음'
                )}
              </div>

              <div
                style={{
                  width: 1,
                  height: 70,
                  backgroundColor: '#ccc',
                }}
              ></div>
              <div
                style={{
                  width: '140px',
                  textAlign: 'center',
                  color: 'gray',
                }}
              >
                {topThreeProductList[i] ? (
                  <span style={{ color: 'black' }}>
                    {topThreeProductList[i].price}원
                  </span>
                ) : (
                  '- 원'
                )}
              </div>

              <div
                style={{
                  width: 1,
                  height: 70,
                  backgroundColor: '#ccc',
                }}
              ></div>
              <div
                style={{
                  width: '140px',
                  textAlign: 'center',
                  color: 'gray',
                }}
              >
                {topThreeProductList[i] ? (
                  <span style={{ color: 'black' }}>
                    {topThreeProductList[i].count}회
                  </span>
                ) : (
                  '- 회'
                )}
              </div>
            </div>
          ))}
        </div>
          ) 
          : (
            <div
          style={{
            width: 740,
            padding: '10px 0px 10px 20px',
            border: '1px solid #c4c4c4',
            borderRadius: 10,
            backgroundColor: 'white',
            marginBottom: '30px',
            position: 'relative',
          }}
        >
          {Array.from({ length: 3 }, (_, i) => i).map((i) => (
            <div
              key={i}
              style={{
                height: 50,
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <div
                style={{
                  width: 29,
                  height: 29,
                  backgroundColor: '#B5B5B5',
                  borderRadius: '50%',
                  textAlign: 'center',
                  color: '#fff',
                  fontSize: 18,
                  fontWeight: 500,
                }}
              >
                {i + 1}
              </div>
              <div
                style={{
                  width: 1,
                  height: 70,
                  backgroundColor: '#ccc',
                  marginLeft: 20,
                }}
              ></div>
              <div style={{ width: 360, marginLeft: 18, color: 'gray' }}>
                {makeShopProductList[i] ? (
                  <span style={{ color: 'black' }}>
                    {makeShopProductList[i].product_name || '상품 이름 없음'}{' '}
                  </span>
                ) : (
                  '데이터 존재하지 않음'
                )}
              </div>

              <div
                style={{
                  width: 1,
                  height: 70,
                  backgroundColor: '#ccc',
                }}
              ></div>
              <div
                style={{
                  width: '140px',
                  textAlign: 'center',
                  color: 'gray',
                }}
              >
                {makeShopProductList[i] ? (
                  <span style={{ color: 'black' }}>
                    {makeShopProductList[i].sellprice}원
                  </span>
                ) : (
                  '- 원'
                )}
              </div>

              <div
                style={{
                  width: 1,
                  height: 70,
                  backgroundColor: '#ccc',
                }}
              ></div>
              <div
                style={{
                  width: '140px',
                  textAlign: 'center',
                  color: 'gray',
                }}
              >
                {makeShopProductList[i] ? (
                  <span style={{ color: 'black' }}>
                    {makeShopProductList[i].view_count}회
                  </span>
                ) : (
                  '- 회'
                )}
              </div>
            </div>
          ))}
        </div>
          )
        }
        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <span
            style={{
              color: '#FF7A00',
              fontWeight: 'bold',
              marginTop: '10px',
              textDecoration: 'underline',
              cursor: 'pointer',
            }}
            onClick={() => {
              makeExcel_todayTop3();
            }}
          >
            전체 내역 다운 받기
          </span>
        </div>
      </div>
      <div className="inner-box" style={{ position: 'relative' }}>
        <p className="subtitle">누적 상세 조회수 TOP10</p>
        <span style={{ color: 'gray', paddingBottom: '10px' }}>
          {year - 1}년 {month}월 ~ {year}년 {month}월 기준
        </span>
        
        <div className="inner-box" style={{ marginTop: 30 }}><canvas id="chart"></canvas></div>
          
        <div
          style={{
            textAlign: 'center',
            position: 'absolute',
            left: '50%',
            top: 'calc(50% + 40px)',
            transform: 'translate(-50%, 0)',
          }}
        >
        {shopMode === 'cafe24' && (productList.length === 0 ? 
          (
            <p
              style={{
                fontSize: 14,
                color: '#848484',
              }}
            >
              데이터가 없습니다.
            </p>
          )
           : (
            calculateSum(productList) === 0 ? 
          (
            <p
              style={{
                fontSize: 14,
                color: '#848484',
              }}
            >
              모든 상품의 조회수가 0 입니다.
            </p>
          )
          :
          (
            <p
              style={{
                fontSize: 16,
                fontWeight: 600,
                color: '#848484',
              }}
            >
              상위 TOP 10 상품
              <br />
              (상세 조회수)
            </p>
          )
          ))}

      {shopMode === 'makeshop' && (makeShopProductList.length === 0 ? 
          (
            <p
              style={{
                fontSize: 14,
                color: '#848484',
              }}
            >
              데이터가 없습니다.
            </p>
          ) :
          calculateSum(makeShopProductList) === 0 || calculateSum(makeShopProductList) === NaN ? 
          (
            <p
              style={{
                fontSize: 14,
                color: '#848484',
              }}
            >
              모든 상품의 조회수가 0 입니다.
            </p>
          ) :
          (
            <p
              style={{
                fontSize: 16,
                fontWeight: 600,
                color: '#848484',
              }}
            >
              상위 TOP 10 상품
              <br />
              (상세 조회수)
            </p>
          )
        )}
        </div>
      </div>

      <div className="inner-box">
        <p className="subtitle">누적 TOP10 세부정보</p>
        <div
          style={{
            width: 740,
            padding: '15px 0px 15px 25px',
            border: '1px solid #c4c4c4',
            borderRadius: 10,
            backgroundColor: 'white',
            marginBottom: '30px',
          }}
        >
          {shopMode === 'cafe24' ? topTenArray() : topTenMakeShopProductArray()}
        </div>

        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <span
            style={{
              color: '#FF7A00',
              fontWeight: 'bold',
              marginTop: '10px',
              paddingRight: '10px',
              textDecoration: 'underline',
              cursor: 'pointer',
            }}
            onClick={() => {
              console.log('상품 순위');
              openModal();
            }}
          >
            예시 결과 보기
          </span>
          <span
            style={{
              color: '#FF7A00',
              fontWeight: 'bold',
              marginTop: '10px',
              textDecoration: 'underline',
              cursor: 'pointer',
            }}
            onClick={() => {
              makeExcel_top10();
            }}
          >
            전체 내역 다운 받기
          </span>
        </div>
      </div>
    </div>
  );
}

export default MyPageStatistics;
